export default __webpack_public_path__ + "static/media/@crisalisaquino.f061ae2d.jpg";